import React from 'react';
import { useDispatch } from 'react-redux';
import { resetRisksState } from './redux/actions/riskActions.js';
import { resetControlsState } from './redux/actions/controlActions.js';
import { resetSecurityState } from './redux/slices/securitySlice.js';
import { resetConfigState } from './redux/actions/configActions.js';
import { persistor } from './redux/store.js';

function RiskFormManager() {
  const dispatch = useDispatch();

  const handleResetAllStates = async () => {
    try {
        await persistor.purge();
        persistor.pause();
        sessionStorage.clear();

        dispatch(resetControlsState());
        dispatch(resetRisksState());
        dispatch(resetSecurityState());
        dispatch(resetConfigState);

        window.location.reload(true);
    } catch (error) {
        console.error('Failed to clear storage:', error);
    }
  };



  return (
    <div style={{ padding: '24px' }}>
      <h2>System Settings</h2>
      <p>Admin tools for managing application state.</p>
      <button onClick={handleResetAllStates}>Reset Entire State</button>
    </div>
  );
}

export default RiskFormManager;
